import { OpenAPI, RequestHeaders, SessionStorageKeys } from '@aglenergy/shared-library';
import { configService } from 'app/shared/services/config/config.service';

class OpenApiService {
  public composeHttpHeaders(contentMode?: string): Record<string, string> {
    let requestHeaders: Record<string, string> = {
      'Ocp-Apim-Subscription-Key': configService.getConfigData().bffOcpApimSubscriptionKey
    };

    if (contentMode) {
      requestHeaders = {
        ...requestHeaders,
        'Content-Mode': contentMode
      };
    }

    this.setAuthAccessToken();
    OpenAPI.HEADERS = RequestHeaders.compose(requestHeaders);
    return OpenAPI.HEADERS;
  }

  public setBaseUrl(): void {
    OpenAPI.BASE = configService.getConfigData().bffApiUrl;
  }

  private setAuthAccessToken(): void {
    const token = sessionStorage.getItem(SessionStorageKeys.AccessToken);
    if (token) {
      OpenAPI.TOKEN = token;
    }
  }
}

export const openApiService = new OpenApiService();
